function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "shield-tool_svg__a",
  x1: 0,
  y1: 0,
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ff3363",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ff33a7",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shield-tool_svg__b",
  x1: 0,
  y1: 0,
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#f7661c",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ffb62f",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shield-tool_svg__c",
  x1: 0,
  y1: 0,
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00cc81",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00cbc6",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "shield-tool_svg__critical",
  fill: "url(#shield-tool_svg__a)",
  clipRule: "evenodd",
  d: "M19.945 3.75C15.825 3.75 12.668 2.58 10 0 7.333 2.58 4.175 3.75.054 3.75.054 10.47-1.342 20.09 10 24c11.341-3.91 9.945-13.53 9.945-20.25z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "shield-tool_svg__normal",
  fill: "url(#shield-tool_svg__b)",
  clipRule: "evenodd",
  d: "M19.945 3.75C15.825 3.75 12.668 2.58 10 0 7.333 2.58 4.175 3.75.054 3.75.054 10.47-1.342 20.09 10 24c11.341-3.91 9.945-13.53 9.945-20.25z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "shield-tool_svg__good",
  fill: "url(#shield-tool_svg__c)",
  clipRule: "evenodd",
  d: "M19.945 3.75C15.825 3.75 12.668 2.58 10 0 7.333 2.58 4.175 3.75.054 3.75.054 10.47-1.342 20.09 10 24c11.341-3.91 9.945-13.53 9.945-20.25z"
});

function SvgShieldTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 24"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "c0500cb862e3133583c4444112f7526a.svg";
export { SvgShieldTool as ReactComponent };